import React, {useState} from "react";
import {Dialog, DialogActions, DialogContent, DialogTitle, Grid2, MenuItem} from "@mui/material";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CustomTextField from "../../../../../components/customMUIComponents/CustomTextField";
import {SocietyOpeningHoursDTO} from "../../../../../context/SocietyProvider";
import useDataPut from "../../../../../hooks/useDataPut";
import useSociety from "../../../../../hooks/useSociety";


interface AddMediaModalProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    openingHours: SocietyOpeningHoursDTO
}

const daysOfWeek = ['Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi', 'Dimanche'];

// Define a type for the opening hours of a single day
interface DailyHours {
    isOpen: boolean;
    openingTime: string;
    closingTime: string;
}

const EditOpeningHoursModal = ({open, setOpen, openingHours}: AddMediaModalProps) => {

    const {society} = useSociety();

    const {putDataPromise} = useDataPut<SocietyOpeningHoursDTO>(`/societies/${society.id}/opening-hours`, undefined, true, false,false);

    const [dailyHours, setDailyHours] = useState<DailyHours[]>( daysOfWeek.map((_, index) => ({ isOpen: openingHours.daysOpen[index] || false, openingTime: openingHours.openingTimes[index], closingTime: openingHours.closingTimes[index]})) );

    const handleToggleDayStatus = (indexToUpdate: number) => {
        const newDailyHours = dailyHours.map((day, index) => {
            if (index === indexToUpdate) {
                return { ...day, isOpen: !day.isOpen };
            }
            return day;
        });
        setDailyHours(newDailyHours);
    };

    const handleOpeningTimeChange = (indexToUpdate: number, time: string) => {
        const newDailyHours = dailyHours.map((day, index) => {
            if (index === indexToUpdate) {
                return { ...day, openingTime: time };
            }
            return day;
        });
        setDailyHours(newDailyHours);
    };

    const handleClosingTimeChange = (indexToUpdate: number, time: string) => {
        const newDailyHours = dailyHours.map((day, index) => {
            if (index === indexToUpdate) {
                return { ...day, closingTime: time };
            }
            return day;
        });
        setDailyHours(newDailyHours);
    };

    const handleConfirm = () => {
        putDataPromise(undefined, {
            daysOpen: dailyHours.map(day => day.isOpen),
            openingTimes: dailyHours.map(day => day.openingTime),
            closingTimes: dailyHours.map(day => day.closingTime)
        }).then(() => {
            window.location.reload();
        }).catch((error) => {
            console.error("Error updating opening hours:", error);
        })
        setOpen(false);
    };

    return (
        <>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <DialogTitle>
                    <Typography variant={"secondVariant"} fontSize={{xs: 18, sm: 20, md: 22}}>
                        Définir les horaires
                    </Typography>
                </DialogTitle>
                <DialogContent sx={{
                    minWidth: '300px'
                }}>

                    <Typography variant={"firstVariant"} mb={2}>
                        Aucun horaire n'est affiché si tous les jours sont fermés.
                    </Typography>

                    <form>
                        {daysOfWeek.map((day, index) => (
                            <Grid2 container spacing={2} key={index} alignItems="center" style={{marginBottom: '1rem'}}>
                                <Grid2 size={12}>
                                    <Typography variant="firstVariant">
                                        {day}
                                    </Typography>
                                </Grid2>
                                <Grid2 container size={12}>
                                    <CustomTextField
                                        variant={"outlined"}
                                        label={'Statut'}
                                        value={dailyHours[index].isOpen ? 'Ouvert' : 'Fermé'}
                                        setField={() => handleToggleDayStatus(index)}
                                        select
                                        selectOptions={['Ouvert', 'Fermé'].map((key) => {
                                            return (
                                                <MenuItem key={key} value={key}>{key}</MenuItem>
                                            )
                                        })}
                                        textAlign={"left"}
                                        required
                                    />
                                </Grid2>
                                {dailyHours[index].isOpen && (
                                    <Grid2 container size={12} spacing={2}>
                                        <Grid2 size={6}>
                                            <label htmlFor={`opening-time-${index}`}>Ouverture</label>
                                            <input
                                                type="time"
                                                id={`opening-time-${index}`}
                                                className="time-input"
                                                value={dailyHours[index].openingTime}
                                                onChange={(e) => handleOpeningTimeChange(index, e.target.value)}
                                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc'}}
                                            />
                                        </Grid2>
                                        <Grid2 size={6}>
                                            <label htmlFor={`closing-time-${index}`}>Fermeture</label>
                                            <input
                                                type="time"
                                                id={`closing-time-${index}`}
                                                className="time-input"
                                                value={dailyHours[index].closingTime}
                                                onChange={(e) => handleClosingTimeChange(index, e.target.value)}
                                                style={{width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc'}}
                                            />
                                        </Grid2>
                                    </Grid2>
                                )}
                            </Grid2>
                        ))}
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>Annuler</Button>
                    <Button onClick={handleConfirm}>
                        Confirmer
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

export default EditOpeningHoursModal;
